import React from "react";
import "../../styles/pre-auth.css";
import { useTranslation } from "react-i18next";
import { Box, Typography, Paper } from "@mui/material";

const Encounter = ({ item }) => {
  const { t } = useTranslation();

  const details = [
    { label: t("Status"), value: item?.status },
    { label: t("Service Type"), value: item?.service_type },
    { label: t("Class"), value: item?.class },
    { label: t("Priority"), value: item?.priority },
    { label: t("Period Start"), value: item?.period_start },
    { label: t("Period End"), value: item?.period_end },
    { label: t("Admin Source"), value: item?.admin_source },
    { label: t("Readmission"), value: item?.readmission },
    { label: t("Discharge Disposition"), value: item?.discharge_disposition },
    {
      label: t("Eligibility Purpose Identifier (Url)"),
      value: item?.Eligibility_Purpose_Identifier_url,
    },
    {
      label: t("Eligibility Purpose Identifier (Value)"),
      value: item?.Eligibility_Purpose_Identifier_value,
    },
  ];

  return (
    <Paper
      elevation={0}
      className="!mt-2 border !rounded-lg overflow-hidden"
      sx={{ border: "1px solid #e2e8f0" }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#d1d5db",
          px: 2,
          py: 0.75,
          borderBottom: "2px solid #d1d5db",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: "0.7rem",
            fontWeight: 700,
            color: "#1e293b",
            textTransform: "uppercase",
            letterSpacing: "0.025em",
          }}
        >
          {t("Encounter Details")}
        </Typography>
      </Box>

      {/* Body - Grid Layout */}
      <Box className="p-3 bg-white">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-y-3 gap-x-3">
          {details.map((detail, index) => (
            <div key={index} className="flex flex-col">
              <span className="text-[11px] font-bold text-gray-500 uppercase tracking-wider  whitespace-pre-wrap">
                {detail.label}
              </span>
              <span className="text-[11px] font-semibold text-[#0070C2] truncate">
                {detail.value || "___"}
              </span>
            </div>
          ))}
        </div>
      </Box>
    </Paper>
  );
};

export default Encounter;
